import { Component, ErrorHandler, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { SopimusTaukoHalutaanLopettaaRequest, SopimusTaukoHalutaanLopettaaResponse } from '@lemon/core-firebase/model/sopimus'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'
import { firstValueFrom } from 'rxjs'

@Component({
  templateUrl: './sopimus-tauolla.component.html',
  styleUrls: ['./sopimus-tauolla.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SopimusTauollaComponent implements OnInit {
  readonly ilmoitusLahetetty = signal(false)
  readonly commonError = signal<string>(undefined)

  constructor(
    private _firebaseLemonaid: FirebaseLemonaid,
    private _kayttajaService: KayttajaService,
    private _ladataanService: LadataanService,
    private _translationService: LemonTranslationService,
    private _errorHandler: ErrorHandler,
  ) {}

  ngOnInit() {}

  async lopetaTauko() {
    this._ladataanService.aloitaLataaminen()

    try {
      const kayttaja = await firstValueFrom(this._kayttajaService.kayttajaObservable)

      if (!kayttaja) {
        return
      }

      const response = await this._firebaseLemonaid.functionsCall<SopimusTaukoHalutaanLopettaaRequest, SopimusTaukoHalutaanLopettaaResponse>('sopimuksenTaukoHalutaanLopettaa', '')

      if (!response || response.e) {
        throw new Error('Sopimuksen tauon lopettamisen pyynnön lähettäminen epäonnistui: ' + response?.e || 'No response')
      }
      this.ilmoitusLahetetty.set(true)
    } catch (error: any) {
      this.commonError.set(this._translationService.lokalisoi('yleiset.tuntematon-virhe', this._translationService.nykyinenKieli))
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }
}
